export default __webpack_public_path__ + "static/media/TF5-2.93265c9b.jpg";